var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-box-demo"},[_c('a-slider',{attrs:{"min":0,"max":1,"step":0.01},model:{value:(_vm.alphaValue),callback:function ($$v) {_vm.alphaValue=$$v},expression:"alphaValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }